import {
	GET_MINE_GENERALS,
	ADD_GENERAL,
} from '@/api/api.generals.js'
import {
	PATCH_ENTITY_BY_ID,
	GET_ENTITY,
	DELETE_ENTITY
} from '@/api/api.commons.js'
import Vue from 'vue'

export default {
	namespaced: true,
	state: {
		map: {},
		page: {
			size: 10,
			totalElements: 0,
			totalPages: 0,
			number: 0,
		},
	},
	getters: {
		mine_general_total(state) {
			return state.page.totalElements
		},
		general(state) {
			return (id) => state.map[id]
		},
		generals(state) {
			return Object.keys(state.map).map(id => state.map[id])
		},
		search_generals(state) {
			return (name) => {
				if (!name || name.length === 0) {
					return Object.keys(state.map).map(id => state.map[id])
				}
				return Object.keys(state.map).filter(id => state.map[id].name.includes(name)).map(id => state.map[id])
			}
		},
		noMore(state) {
			return state.page.number >= state.page.totalPages
		}
	},
	mutations: {
		putToMap(state, {
			id,
			record
		}) {
			Vue.set(state.map, id, record)
		},
		removeFromMap(state, ids = []) {
			for (let id of ids) {
				Vue.delete(state.map, id)
			}
			state.page.totalElements -= ids.length
		},
		clearMap(state) {
			state.map = {}
		},
		setPage(state, data = {}) {
			state.page = Object.assign(state.page, data)
		},
		nextPage(state) {
			state.page.number += 1
		}
	},
	actions: {
		async delete_general({
			commit
		}, id) {
			await DELETE_ENTITY(`/generals/${id}`)
			commit("removeFromMap", [id])
		},
		
		async patch_general({
			commit
		}, {
			id,
			data = {}
		}) {
			const record = await PATCH_ENTITY_BY_ID({
				domain: 'generals',
				id,
				data,
			})
			id = record['id']
			commit("putToMap", {
				id,
				record
			})
		},

		async get_general({
			commit
		}, {
			id,
			params = {}
		}) {
			const record = await GET_ENTITY({
				uri: `/generals/${id}`,
				params
			})
			commit("putToMap", {
				id,
				record
			})
		},

		async create_general({
			commit
		}, data = {
			name: '我的概览',
			layout: []
		}) {
			const record = await ADD_GENERAL({
				...data,
				layout: JSON.stringify(data.layout)
			})
			let id = record['id']
			commit("putToMap", {
				id,
				record
			})
		},

		async get_mine_generals({
			commit,
			state
		}, {
			page = undefined,
			size = 20
		}) {
			if (page === undefined) {
				page = state.page.number + 1
			}
			const generals = await GET_MINE_GENERALS({
				page,
				size
			})
			commit('setPage', generals['page'])
			if (generals['_embedded'] === undefined) {
				return
			}
			for (let record of generals['_embedded']['entityModels']) {
				let id = record['id']
				commit("putToMap", {
					id,
					record
				})
			}
		},

		/**
		 * @description 用户登录后从持久化数据加载一系列的设置
		 * @param {Object} context
		 */
		async load({
			dispatch,
		}, auth = true) {
			auth && dispatch('get_mine_generals', {
				page: 0,
				size: 20
			})
		}
	}
}
